import { axiosInstance } from './apiCommon';

export const getPublicSiteHost = async () => (await axiosInstance.get<string>('/api/v1/EPDLibrary/PublicSiteHost')).data;
